<template>
  <div class="wait-clock-page">
    <div class="clock-type-tabs" role="radiogroup" aria-label="钟型选择">
      <button
        v-for="clockType in clockTypeOptions"
        :key="clockType"
        type="button"
        role="radio"
        class="clock-type-tab"
        :class="{ active: form.clockType === clockType }"
        :aria-checked="form.clockType === clockType"
        @click="changeClockType(clockType)"
      >
        {{ clockType }}
      </button>
    </div>

    <main class="form-content">
      <div v-if="isQueueClock" class="form-row">
        <label class="form-label">技师类型：</label>
        <button type="button" class="field-box select-field" @click="openTechnicianTypePicker">
          <span :class="{ placeholder: !form.technicianTypeName }">
            {{ form.technicianTypeName || "请选择技师类型" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div v-else class="form-row">
        <label class="form-label" for="technician-code">技师号：</label>
        <input
          id="technician-code"
          v-model.trim="form.technicianCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入技师号"
        />
      </div>

      <div class="form-row">
        <label class="form-label">项目名称：</label>
        <button type="button" class="field-box select-field" @click="showProjectPicker = true">
          <span :class="{ placeholder: !form.projectName }">
            {{ form.projectName || "请选择项目" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label" for="hand-code">手牌号：</label>
        <input
          id="hand-code"
          v-model.trim="form.handCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入手牌号"
        />
      </div>

      <div class="form-row">
        <label class="form-label">房间号：</label>
        <button type="button" class="field-box select-field" @click="showRoomPicker = true">
          <span :class="{ placeholder: !form.roomName }">
            {{ form.roomName || "请选择房间" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label" for="clock-count">做钟数量：</label>
        <div class="field-box count-field">
          <button
            type="button"
            aria-label="减少做钟数量"
            :disabled="form.clockCount <= minClockCount"
            @click="changeClockCount(-1)"
          >
            −
          </button>
          <input
            id="clock-count"
            v-model.number="form.clockCount"
            type="number"
            inputmode="decimal"
            :min="minClockCount"
            :max="maxClockCount"
            step="1"
            @blur="normalizeClockCount"
          />
          <button
            type="button"
            aria-label="增加做钟数量"
            :disabled="form.clockCount >= maxClockCount"
            @click="changeClockCount(1)"
          >
            ＋
          </button>
        </div>
      </div>
    </main>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">取消</button>
      <button type="button" class="footer-button save-button" @click="handleSave">确认派钟</button>
    </footer>

    <van-popup v-model="showTechnicianTypePicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择技师类型"
        value-key="name"
        :columns="technicianTypeOptions"
        @confirm="confirmTechnicianType"
        @cancel="showTechnicianTypePicker = false"
      />
    </van-popup>

    <project-select-popup
      v-model="showProjectPicker"
      :projects="projectOptions"
      :selected-id="form.projectId"
      @confirm="confirmProject"
    />

    <room-select-popup
      v-model="showRoomPicker"
      :rooms="roomOptions"
      :categories="roomCategoryOptions"
      :selected-id="form.roomId"
      @confirm="confirmRoom"
    />
  </div>
</template>

<script>
import ProjectSelectPopup from "@/components/jishi/ProjectSelectPopup";
import RoomSelectPopup from "@/components/jishi/RoomSelectPopup";

const QUEUE_CLOCK = "排钟";

export default {
  name: "JiShiWaitClock",
  components: {
    ProjectSelectPopup,
    RoomSelectPopup,
  },
  data() {
    return {
      clockTypeOptions: ["排钟", "点钟", "选钟", "Call钟"],
      showTechnicianTypePicker: false,
      showProjectPicker: false,
      showRoomPicker: false,
      minClockCount: 1,
      maxClockCount: 20,
      form: {
        clockType: QUEUE_CLOCK,
        technicianCode: "007",
        technicianTypeId: "massage",
        technicianTypeName: "按摩技师",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
      technicianTypeOptions: [
        { id: "chinese", name: "中医技师" },
        { id: "spa", name: "SPA技师" },
        { id: "massage", name: "按摩技师" },
        { id: "bath", name: "搓澡技师" },
      ],
      projectOptions: [
        { id: "6001", name: "精油按摩", price: 299, unit: "次" },
        { id: "6002", name: "颈肩按摩", price: 398, unit: "次" },
        { id: "6003", name: "足底按摩", price: 268, unit: "次" },
        { id: "6004", name: "全身推拿", price: 368, unit: "次" },
        { id: "6005", name: "艾灸养生", price: 168, unit: "次" },
        { id: "6006", name: "特价按摩", price: 98, unit: "次" },
      ],
      roomCategoryOptions: ["全部", "双人间三楼", "大床房三楼", "双人棋牌室", "大床房"],
      roomOptions: [
        { id: "00001", name: "00001", type: "按摩房", category: "双人间三楼", status: "preClock", detailLines: ["开 6002　按 6003", "02 颈肩按摩　点"], elapsed: "00:23" },
        { id: "00002", name: "00002", type: "大床房", category: "大床房三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "02:36" },
        { id: "00003", name: "00003", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "00:12", timeout: true },
        { id: "00004", name: "00004", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00005", name: "00005", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00006", name: "00006", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "02:19" },
      ],
    };
  },
  computed: {
    /**
     * 判断当前是否选择“排钟”。模板通过该值决定显示技师类型还是技师号，
     * 保存校验也复用同一判断，避免界面规则与提交规则不一致。
     */
    isQueueClock() {
      return this.form.clockType === QUEUE_CLOCK;
    },
  },
  created() {
    this.initializeForm();
  },
  methods: {
    /**
     * 使用路由参数初始化表单。外部钟房页面可传技师号和手牌号；没有传值时
     * 使用演示默认值，确保直接访问当前路由仍能看到完整页面。
     */
    initializeForm() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      this.form.technicianCode = query.technicianCode || this.form.technicianCode;
      this.form.handCode = query.handCode || this.form.handCode;
    },
    /**
     * 切换顶部钟型单选。选择排钟时模板自动隐藏技师号并显示技师类型；切换到
     * 其他钟型时恢复技师号输入。已有字段值会保留，来回切换不会丢失用户输入。
     *
     * @param {string} clockType 用户点击的钟型名称。
     */
    changeClockType(clockType) {
      this.form.clockType = clockType;
    },
    /**
     * 打开技师类型底部选择器。该入口只在排钟模式下显示。
     */
    openTechnicianTypePicker() {
      this.showTechnicianTypePicker = true;
    },
    /**
     * 接收 van-picker 单选返回的技师类型，同步 id 和展示名称后关闭弹窗。
     *
     * @param {Object} technicianType 选中的技师类型，包含 id 和 name。
     */
    confirmTechnicianType(technicianType) {
      if (!technicianType) {
        return;
      }
      this.form.technicianTypeId = technicianType.id;
      this.form.technicianTypeName = technicianType.name;
      this.showTechnicianTypePicker = false;
    },
    /**
     * 接收 ProjectSelectPopup 确认的项目。子组件取消时不会调用本方法。
     *
     * @param {Object} project 已确认的项目对象。
     */
    confirmProject(project) {
      if (!project) {
        return;
      }
      this.form.projectId = project.id;
      this.form.projectName = project.name;
    },
    /**
     * 接收 RoomSelectPopup 确认的房间。子组件中的搜索、筛选和临时单选不会
     * 提前改变表单，只有点击确认后才会进入本方法。
     *
     * @param {Object} room 已确认的房间对象。
     */
    confirmRoom(room) {
      if (!room) {
        return;
      }
      this.form.roomId = room.id;
      this.form.roomName = room.name;
    },
    /**
     * 按 0.5 的步长增加或减少做钟数量，并将结果限制在允许的最小值和最大值内。
     *
     * @param {number} direction 1 表示增加，-1 表示减少。
     */
    changeClockCount(direction) {
      const currentValue = Number(this.form.clockCount) || this.minClockCount;
      const nextValue = currentValue + direction * 1;
      this.form.clockCount = Math.min(
        this.maxClockCount,
        Math.max(this.minClockCount, nextValue)
      );
    },
    /**
     * 规范用户手动输入的做钟数量。非数字恢复最小值，超限值会被截取，并统一
     * 四舍五入到最接近的 0.5，保证提交给接口的数据格式稳定。
     */
    normalizeClockCount() {
      const inputValue = Number(this.form.clockCount);
      const safeValue = Number.isFinite(inputValue) ? inputValue : this.minClockCount;
      const limitedValue = Math.min(
        this.maxClockCount,
        Math.max(this.minClockCount, safeValue)
      );
      this.form.clockCount = Math.round(limitedValue * 2);
    },
    /**
     * 取消当前待钟编辑并返回上一页。直接访问页面且没有历史记录时保持当前页。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 按钟型规则校验并提交待钟数据。排钟必须选择技师类型，非排钟必须填写
     * 技师号；公共字段统一校验。当前通过 submit 事件输出数据，便于后续接接口。
     */
    handleSave() {
      this.normalizeClockCount();
      if (this.isQueueClock && !this.form.technicianTypeId) {
        this.$toast("请选择技师类型");
        return;
      }
      if (!this.isQueueClock && !this.form.technicianCode) {
        this.$toast("请输入技师号");
        return;
      }
      if (!this.form.projectId) {
        this.$toast("请选择项目");
        return;
      }
      if (!this.form.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      if (!this.form.roomId) {
        this.$toast("请选择房间");
        return;
      }
      this.$emit("submit", { ...this.form });
      this.$toast.success("保存成功");
    },
  },
};
</script>

<style scoped lang="scss">
.wait-clock-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.clock-type-tabs {
  display: flex;
  padding: 22px 28px 0;
  gap: 18px;
}

.clock-type-tab {
  position: relative;
  height: 64px;
  flex: 1;
  border: 1px solid #ddd5c7;
  border-radius: 10px;
  color: #55514b;
  background: #fff;
  font-size: 25px;

  &.active {
    border-color: #caa55f;
    color: #9d7a3c;
    background: #f6eddd;
    box-shadow: inset 0 0 0 1px #e1c99e;
  }
}

.form-content {
  padding: 30px 34px 0 28px;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  margin-left: 20px;
  padding: 0 24px;
  flex: 1;
  align-items: center;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  box-shadow: 0 1px 4px rgba(117, 101, 70, 0.06);
  font-size: 25px;
  text-align: left;
}

.text-input {
  width: 0;
  outline: none;

  &::placeholder {
    color: #bcb5a8;
  }
}

.select-field {
  justify-content: space-between;

  .placeholder {
    color: #bcb5a8;
  }
}

.arrow-icon {
  width: 10px;
  height: 10px;
  margin-left: 18px;
  border-top: 2px solid #b09a6d;
  border-right: 2px solid #b09a6d;
  transform: rotate(45deg);
}

.count-field {
  justify-content: space-between;
  padding: 0;
  overflow: hidden;

  button {
    width: 72px;
    height: 100%;
    padding: 0;
    border: 0;
    color: #a4894f;
    background: #faf6ef;
    font-size: 31px;

    &:disabled {
      color: #d6cec0;
      background: #fbfaf7;
    }
  }

  input {
    width: 100px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: transparent;
    font-size: 26px;
    text-align: center;
    outline: none;
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
    }
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  padding: 12px 30px env(safe-area-inset-bottom);
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}

::v-deep .van-picker__confirm {
  color: #b08d4d;
}

::v-deep .van-picker__cancel {
  color: #8b857b;
}
</style>
<template>
  <div class="wait-clock-page">
    <nav class="clock-type-tabs" aria-label="钟型选择">
      <button
        v-for="item in clockTypeOptions"
        :key="item.value"
        type="button"
        :class="{ active: form.clockType === item.value }"
        @click="changeClockType(item.value)"
      >
        {{ item.label }}
      </button>
    </nav>

    <main class="form-content">
      <div v-if="isQueueClock" class="form-row">
        <label class="form-label">技师类型：</label>
        <button type="button" class="field-box select-field" @click="showTechnicianTypePicker = true">
          <span :class="{ placeholder: !form.technicianTypeName }">
            {{ form.technicianTypeName || "请选择技师类型" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div v-else class="form-row">
        <label class="form-label" for="technician-code">技师号：</label>
        <input
          id="technician-code"
          v-model.trim="form.technicianCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入技师号"
        />
      </div>

      <div class="form-row">
        <label class="form-label">项目名称：</label>
        <button type="button" class="field-box select-field" @click="showProjectPicker = true">
          <span :class="{ placeholder: !form.projectName }">
            {{ form.projectName || "请选择项目" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label" for="hand-code">手牌号：</label>
        <input
          id="hand-code"
          v-model.trim="form.handCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入手牌号"
        />
      </div>

      <div class="form-row">
        <label class="form-label">房间号：</label>
        <button type="button" class="field-box select-field" @click="showRoomPicker = true">
          <span :class="{ placeholder: !form.roomName }">
            {{ form.roomName || "请选择房间" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label">做钟数量：</label>
        <div class="field-box number-stepper">
          <button
            type="button"
            :disabled="form.clockCount <= 0.5"
            @click="changeNumber('clockCount', -1, 0.5, 20, 0.5)"
          >−</button>
          <span>{{ form.clockCount }}</span>
          <button
            type="button"
            :disabled="form.clockCount >= 20"
            @click="changeNumber('clockCount', 1, 0.5, 20, 0.5)"
          >＋</button>
        </div>
      </div>

      <div v-if="isQueueClock" class="form-row">
        <label class="form-label">派工数：</label>
        <div class="field-box number-stepper">
          <button
            type="button"
            :disabled="form.dispatchCount <= 1"
            @click="changeNumber('dispatchCount', -1, 1, 99, 1)"
          >−</button>
          <span>{{ form.dispatchCount }}</span>
          <button
            type="button"
            :disabled="form.dispatchCount >= 99"
            @click="changeNumber('dispatchCount', 1, 1, 99, 1)"
          >＋</button>
        </div>
      </div>
    </main>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">取消</button>
      <button type="button" class="footer-button save-button" @click="handleSave">保存</button>
    </footer>

    <project-select-popup
      v-model="showProjectPicker"
      :projects="projectOptions"
      :selected-id="form.projectId"
      @confirm="confirmProject"
    />
    <room-select-popup
      v-model="showRoomPicker"
      :rooms="roomOptions"
      :categories="roomCategoryOptions"
      :selected-id="form.roomId"
      @confirm="confirmRoom"
    />
    <technician-type-select-popup
      v-model="showTechnicianTypePicker"
      :options="technicianTypeOptions"
      :selected-id="form.technicianTypeId"
      @confirm="confirmTechnicianType"
    />
  </div>
</template>

<script>
import ProjectSelectPopup from "@/components/jishi/ProjectSelectPopup";
import RoomSelectPopup from "@/components/jishi/RoomSelectPopup";
import TechnicianTypeSelectPopup from "@/components/jishi/TechnicianTypeSelectPopup";

export default {
  name: "JiShiWaitClock",
  components: {
    ProjectSelectPopup,
    RoomSelectPopup,
    TechnicianTypeSelectPopup,
  },
  data() {
    return {
      showProjectPicker: false,
      showRoomPicker: false,
      showTechnicianTypePicker: false,
      clockTypeOptions: [
        { label: "排钟", value: "queue" },
        { label: "点钟", value: "point" },
        { label: "选钟", value: "select" },
        { label: "Call钟", value: "call" },
      ],
      technicianTypeOptions: [
        { id: "beauty", name: "美容技师" },
        { id: "massage", name: "按摩技师" },
        { id: "spa", name: "SPA技师" },
        { id: "medicine", name: "中医技师" },
      ],
      form: {
        clockType: "queue",
        technicianCode: "007",
        technicianTypeId: "",
        technicianTypeName: "",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
        dispatchCount: 1,
      },
      projectOptions: [
        { id: "6001", name: "精油按摩", price: 299, unit: "成人" },
        { id: "6002", name: "颈肩按摩", price: 398, unit: "1大1小" },
        { id: "6003", name: "足底按摩", price: 668, unit: "成人" },
        { id: "6004", name: "全身推拿", price: 68, unit: "成人" },
      ],
      roomCategoryOptions: ["全部", "双人间三楼", "大床房三楼", "双人棋牌室"],
      roomOptions: [
        { id: "00001", name: "00001", type: "按摩房", category: "双人间三楼", status: "preClock", detailLines: ["开 6002　按 6003"], elapsed: "00:23" },
        { id: "00002", name: "00002", type: "大床房", category: "大床房三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "02:36" },
        { id: "00003", name: "00003", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "00:12", timeout: true },
        { id: "00004", name: "00004", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00005", name: "00005", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00006", name: "00006", type: "标准间", category: "双人间三楼", status: "cleaning", detailLines: ["脏房：01:30"] },
      ],
    };
  },
  computed: {
    /**
     * 判断当前钟型是否为排钟。
     * 模板通过该值统一控制“技师类型/技师号”切换及“派工数”是否显示。
     */
    isQueueClock() {
      return this.form.clockType === "queue";
    },
  },
  methods: {
    /**
     * 切换顶部钟型单选。
     * 切换到排钟时保留技师号但不展示；切换到其他钟型时保留已选技师类型，
     * 避免用户来回切换时重复填写，保存时只提交当前钟型需要的字段。
     *
     * @param {string} clockType 用户选择的钟型值。
     */
    changeClockType(clockType) {
      this.form.clockType = clockType;
    },
    /**
     * 接收技师类型组件确认的完整对象并写入表单。
     *
     * @param {Object} type 已确认的技师类型，包含 id 和 name。
     */
    confirmTechnicianType(type) {
      if (!type) return;
      this.form.technicianTypeId = type.id;
      this.form.technicianTypeName = type.name;
    },
    /**
     * 接收项目选择组件确认结果并更新项目字段。
     *
     * @param {Object} project 已确认的项目对象。
     */
    confirmProject(project) {
      if (!project) return;
      this.form.projectId = project.id;
      this.form.projectName = project.name;
    },
    /**
     * 接收房间选择组件确认结果并更新房间字段。
     *
     * @param {Object} room 已确认的房间对象。
     */
    confirmRoom(room) {
      if (!room) return;
      this.form.roomId = room.id;
      this.form.roomName = room.name;
    },
    /**
     * 修改表单中的数字字段，并按调用方提供的范围和步长限制最终结果。
     * 做钟数量使用 0.5 步长，派工数使用整数步长；统一方法可以避免两套加减
     * 逻辑产生不同的边界行为。
     *
     * @param {string} field 需要修改的 form 字段名。
     * @param {number} direction 1 表示增加，-1 表示减少。
     * @param {number} min 允许的最小值。
     * @param {number} max 允许的最大值。
     * @param {number} step 每次点击改变的数值。
     */
    changeNumber(field, direction, min, max, step) {
      const nextValue = Number(this.form[field]) + direction * step;
      const limitedValue = Math.min(max, Math.max(min, nextValue));
      this.form[field] = Math.round(limitedValue * 10) / 10;
    },
    /**
     * 取消当前编辑并返回上一页；直接访问该路由且没有历史页面时保持不动。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 按当前钟型校验并输出待钟表单。
     * 排钟要求技师类型和派工数，非排钟要求技师号；公共字段始终要求项目、
     * 手牌号、房间和做钟数量。校验成功后通过 submit 事件交给接口层处理。
     */
    handleSave() {
      if (this.isQueueClock && !this.form.technicianTypeId) {
        this.$toast("请选择技师类型");
        return;
      }
      if (!this.isQueueClock && !this.form.technicianCode) {
        this.$toast("请输入技师号");
        return;
      }
      if (!this.form.projectId || !this.form.handCode || !this.form.roomId) {
        this.$toast("请完善待钟信息");
        return;
      }
      const submitData = { ...this.form };
      if (this.isQueueClock) {
        delete submitData.technicianCode;
      } else {
        delete submitData.technicianTypeId;
        delete submitData.technicianTypeName;
        delete submitData.dispatchCount;
      }
      this.$emit("submit", submitData);
      this.$toast.success("保存成功");
    },
  },
};
</script>

<style scoped lang="scss">
.wait-clock-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.clock-type-tabs {
  display: flex;
  padding: 22px 28px 0;
  gap: 18px;

  button {
    height: 64px;
    flex: 1;
    border: 1px solid #ded8cc;
    border-radius: 10px;
    color: #766b5c;
    background: #fff;
    font-size: 25px;

    &.active {
      border-color: #d0aa64;
      color: #fff;
      background: linear-gradient(90deg, #cea95f, #edc470);
    }
  }
}

.form-content {
  padding: 30px 34px 0 28px;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  margin-left: 20px;
  padding: 0 24px;
  flex: 1;
  align-items: center;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  font-size: 25px;
}

.text-input {
  width: 0;
  outline: 0;
}

.select-field {
  justify-content: space-between;
  text-align: left;

  .placeholder {
    color: #bbb3a6;
  }
}

.arrow-icon {
  width: 10px;
  height: 10px;
  border-top: 2px solid #b09a6d;
  border-right: 2px solid #b09a6d;
  transform: rotate(45deg);
}

.number-stepper {
  padding: 0;
  justify-content: space-between;
  overflow: hidden;

  button {
    width: 72px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: #faf6ef;
    font-size: 31px;
  }

  span {
    flex: 1;
    text-align: center;
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  padding: 12px 30px env(safe-area-inset-bottom);
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}
</style>
